
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  AI,
  Answer,
  AIGroup,
  Candidate,
  CandidateResult,
  ColorQuestionAnswerResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import ResultTs from "../result-ai-report";

enum cheatEnum {
  "nameIdCheck" = "身份信息验证（二要素核验）",
  "bgCheckIdentity" = "手机号实名认证",
  "bgCheckFinancial" = "综合B类评估记录",
  "bgCheckSocial" = "综合A类评估记录"
}

const cheatKeys = [
  "nameIdCheck",
  "bgCheckIdentity",
  "bgCheckFinancial",
  "bgCheckSocial"
];

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];
//异常项 对应文案 详情用
const errorEnumTextEX = {
  // nameIdCheck: ["未检测", "未通过", "通过"],
  bgCheckIdentity: ["手机号实名未查询", "手机号实名异常", "通过"],
  bgCheckFinancial: ["综合B类评估未检测", "综合B类评估异常", "通过"],
  bgCheckSocial: ["综合A类评估未检测", "综合A类评估异常", "通过"]
};

@Component({})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  connectCode = "";
  bgCheckList: any = [];

  @Watch("all")
  getAll(nval: CandidateResult) {
    this.getBgCheckList();
  }

  created() {
    //
    // this.getCheatList()
  }

  //
  mounted() {
    this.getBgCheckList();
    // this.connectCode = this.$route.query.connectCode as string;
    // this.isStudent = String(this.$route.query.ver || "") === "1";
  }

  getBgCheckList() {
    this.bgCheckList = [];
    this.all.errorInfoList.forEach(item => {
      if (cheatKeys.includes(item.task)) {
        this.bgCheckList.push({
          name: cheatEnum[item.task],
          type: item.result,
          task: item.task,
          result: errorEnumText[item.result],
          value:
            item.resMessage ||
            errorEnumTextEX?.[item.task]?.[item.result] ||
            errorEnumText[item.result]
        });
      }
    });
  }

  async wait(secends: number) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, secends);
    });
  }
}
